import { useState } from "react";
import { MathShell, Field, ResultCard, MATH_ACCENT } from "./MathShell.jsx";
import { logarithm, round } from "./mathcore.js";

export default function Logarithm() {
  const [val, setVal] = useState("1000");
  const [base, setBase] = useState("10");
  const [res, setRes] = useState(null);

  const go = (mode) => {
    const v = parseFloat(val);
    if (isNaN(v)) { setRes({ ok: false, error: "Enter a numeric value" }); return; }
    if (mode === "ln") { setRes(logarithm(v, null)); return; }
    const b = parseFloat(base);
    if (isNaN(b)) { setRes({ ok: false, error: "Enter a numeric base" }); return; }
    setRes(logarithm(v, b));
  };

  return (
    <MathShell title="Logarithm">
      <Field label="Value" value={val} onChange={(e) => setVal(e.target.value)} inputMode="decimal" />
      <Field label="Base" value={base} onChange={(e) => setBase(e.target.value)} inputMode="decimal" />
      <div style={{ display: "flex", gap: 10 }}>
        <button onClick={() => go("base")} style={btn}>log base b</button>
        <button onClick={() => go("ln")} style={{ ...btn, background: "#1C1E2E", color: "#E8E9F3" }}>ln (natural)</button>
      </div>
      {res && (
        <ResultCard>
          {res.ok ? (
            <div>
              <div style={{ fontSize: 18, fontWeight: 700, color: MATH_ACCENT }}>
                {res.label} = {round(res.result, 8)}
              </div>
              {res.steps && (
                <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid #1C1E2E" }}>
                  {res.steps.map((s, i) => (
                    <div key={i} style={{ fontSize: 13, color: "#C8CADF", fontFamily: "ui-monospace, monospace", padding: "3px 0" }}>{s}</div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <span style={{ color: "#F8716A" }}>{res.error}</span>
          )}
        </ResultCard>
      )}
    </MathShell>
  );
}
const btn = { flex: 1, background: MATH_ACCENT, color: "#06201C", fontWeight: 700, fontSize: 15, border: "none", borderRadius: 12, padding: "13px 0", cursor: "pointer" };

